import React, { useEffect } from "react";
import { CheckCircle, Home, Phone, Mail } from "lucide-react";
import HeaderEN from "../components/en/HeaderEN";
import FooterEN from "../components/en/FooterEN";

const ThankYouPageEN = () => {
  useEffect(() => {
    // Scroll to top on page load
    window.scrollTo(0, 0);
    
    // Optional: Analytics tracking event
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        'send_to': 'CONVERSION_ID', // À remplacer par l'ID réel
        'event_category': 'Contact',
        'event_label': 'Form Submission'
      });
    }
    
    // Optional: Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);

  const goHome = () => {
    window.location.href = '/en';
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6]">
      <HeaderEN />
      
      {/* Conversion Tracking Element */}
      <div id="conversion-tracking" className="conversion-success" style={{display: 'none'}}>
        {/* Conversion tag ready */}
      </div>
      
      <main role="main" className="section-padding">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle size={48} className="text-green-600" />
            </div>
            
            {/* Main Title */}
            <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-[#1C3A27] mb-6">
              Thank you for your enquiry 🌿
            </h1>
            
            {/* Confirmation Message */}
            <p className="text-lg md:text-xl text-[#1C3A27]/80 max-w-2xl mx-auto leading-relaxed mb-8">
              Your message has been sent to Nathalie and Wilhelm. They will get back to you shortly to confirm availability.
            </p>
          </div>

          {/* Follow-up Information */}
          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-[#EDE6DB]/50 mb-8 max-w-2xl mx-auto">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1C3A27] mb-4">
              What happens next?
            </h2>
            <div className="space-y-4 text-left">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">1</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  We review your request and preferred dates
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">2</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  Nathalie & Wilhelm contact you within 24 hours
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-[#1C3A27]/10 rounded-full flex items-center justify-center mt-0.5 flex-shrink-0">
                  <span className="text-[#1C3A27] text-sm font-bold">3</span>
                </div>
                <p className="text-[#1C3A27]/80">
                  We finalize the details of your stay together
                </p>
              </div>
            </div>
          </div>

          {/* Emergency Contact */}
          <div className="bg-[#EDE6DB]/30 rounded-2xl p-6 md:p-8 mb-8 max-w-2xl mx-auto">
            <h3 className="font-serif text-lg md:text-xl font-bold text-[#1C3A27] mb-4">
              Need an immediate response?
            </h3>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+33664104815"
                className="btn-primary bg-green-600 hover:bg-green-700 px-6 py-3 transition-colors"
                aria-label="Call directly - 06 64 10 48 15"
              >
                <Phone size={20} className="flex-shrink-0" />
                <span className="ml-2">📞 06 64 10 48 15</span>
              </a>
              <a
                href="mailto:wilhelm.martel@orange.fr"
                className="btn-secondary px-6 py-3 hover:bg-[#1C3A27] hover:text-white transition-colors"
                aria-label="Send an email"
              >
                <Mail size={20} className="flex-shrink-0" />
                <span className="ml-2">Email us</span>
              </a>
            </div>
          </div>

          {/* Back to Homepage Button */}
          <button
            onClick={goHome}
            className="btn-primary text-base md:text-lg px-6 md:px-8 py-3 md:py-4 hover:bg-[#2A5236] transition-colors transform hover:scale-105"
            aria-label="Back to homepage"
          >
            <Home size={20} className="flex-shrink-0" />
            <span className="ml-2">Back to homepage</span>
          </button>

          {/* Reassurance Message */}
          <div className="mt-8 text-sm text-[#1C3A27]/60">
            <p>Your data is processed with the utmost confidentiality.</p>
            <p className="mt-1">
              Gîte Hearts of Normandy - 31 Rue Notre-Dame, 14570 Clécy, France
            </p>
          </div>
        </div>
      </main>
      
      <FooterEN />
    </div>
  );
};

export default ThankYouPageEN;